import $ from 'jquery'

export default (
  link,
) => {
  const anchorLink = $(link).find('.anchor-link, .to-top-btn a')
  const loadTarget = window.location.hash
  const $root = $('html, body')
  const $window = $(window)

  $window.on('load', () => {
    const headerHeight = $('.site-header').outerHeight()

    // *only* if we have anchor on the url
    if (loadTarget && $(loadTarget).offset()) {
      const loadTargetOffset = $(loadTarget).offset().top
      const preHeaderHeight = window.pageYOffset < loadTargetOffset + headerHeight + 30 ? 4 : 30

      // smooth scroll to the anchor id
      $root.stop().animate({
        scrollTop: $(loadTarget).offset()
          ? loadTargetOffset - headerHeight - preHeaderHeight
          : 0,
      }, 100)
    }
  })

  // Stop scroll animation on user scroll
  $window.on('touchmove mousewheel', () => {
    $root.stop()
  })

  anchorLink.not('[href="#"]').not('[href="#0"]').on('click', (e) => {
    let headerHeightInner = $('.site-header').outerHeight() + 25
    headerHeightInner += parseInt($('.site-header').get(0).getBoundingClientRect().top, 10)
    const $anchor = $(e.currentTarget.hash)
    if ($anchor.length) {
      $root.stop().animate({
        scrollTop: $anchor.offset().top - headerHeightInner,
      }, 100)
    }
    return false
  })
}
